module.exports = __webpack_public_path__ + "img/contributions5On.33c0b509.svg";